import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";
import _ from "lodash";

import { colors } from "theme/palette";

import Box from "components/Box";
import Text from "components/Text";

const BouncingDotsLoader = ({
  loadingText,
  sx,
}: {
  loadingText?: string;
  sx?: SxProps<Theme>;
}) => (
  <Box
    position="fixed"
    top={0}
    left={0}
    width="100%"
    height="100%"
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap={5}
    bgcolor={colors.white}
    zIndex={999}
    sx={{ ...sx }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        "@keyframes bounce": {
          to: {
            opacity: 0.1,
            transform: "translateY(-16px)",
          },
        },
      }}
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 16,
            height: 16,
            mx: 0.75,
            borderRadius: "50%",
            bgcolor: colors.blue100,
            opacity: 1,
            animation: "bounce 0.6s infinite alternate",
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Box>
    {!_.isNil(loadingText) && <Text variant="h1">{loadingText}</Text>}
  </Box>
);

export default BouncingDotsLoader;
